module.exports = __webpack_public_path__ + "img/awards_decoration3.bb1300b7.png";